/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} So_Status_Document_RequestedInputs */

const en_so_status_document_requested = /** @type {(inputs: So_Status_Document_RequestedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document requested`)
};

/**
* | output |
* | --- |
* | "Document requested" |
*
* @param {So_Status_Document_RequestedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const so_status_document_requested = /** @type {((inputs?: So_Status_Document_RequestedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<So_Status_Document_RequestedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_so_status_document_requested(inputs)
});